import { useReplicacheQueryV2 } from '~/hooks-data/use-replicache-query'
import { useSelectedBranchOrCommitQuery } from '../commits/use-selected-branch-or-commit'
import { repoSpaceMutators } from '@basehub/data/replicache/mutators/repo-space/mutators'
import { useRepoReplicache } from '~/hooks-data/use-repo-replicache'
import { invariant } from '@epic-web/invariant'
import { isBranch } from '@basehub/data/replicache/index'

export const useSelectedBranchContentRequest = () => {
  const { data } = useSelectedBranchOrCommitQuery()
  const { replicache } = useRepoReplicache().data ?? {}
  const crId = data && isBranch(data) ? data.contentRequestIds?.[0] : null

  const query = useReplicacheQueryV2({
    key: ['content-request', crId],
    replicache,
    fetcher: async (tx) => {
      invariant(crId, 'shouldnt be enabled')
      return (await repoSpaceMutators.getContentRequest(tx, crId)) ?? null
    },
    enabled: !!crId,
    keepPreviousData: true,
  })

  return query.data
}
